import { CityClinic, Clinic, Districts, MedpressClinic } from '@customTypes/Clinic'
import { clinicServiceClient, medpressClient, publicClient } from './apiClients'

export const getClinic = async (clinicReferenceId: string): Promise<Clinic> => {
  const { data } = await clinicServiceClient.get(`clinics/${clinicReferenceId}`)
  return data
}

export const getClinicsInCityForSelectedTreatment = async (
  clinicReferenceId: string,
  treatmentPurposeReferenceId: string,
  cityName: string | undefined,
  district: string | undefined,
  latitude: string | number | undefined | null,
  longitude: string | number | undefined | null
): Promise<CityClinic[]> => {
  const params = {
    clinicReferenceId,
    city: cityName,
    federalState: district,
    longitude,
    latitude,
  }

  const { data } = await publicClient.get(`/bookable-treatment-bundles/${treatmentPurposeReferenceId}/clinics`, {
    params,
  })

  return data
}

export const getMedpressClinic = async (id: string): Promise<MedpressClinic> => {
  const { data } = await medpressClient.get(`v1/clinics/${id}`)

  return data
}

export const getDistrictsForSelectedTreatment = async (treatmentPurposeReferenceId: string): Promise<Districts> => {
  const { data } = await publicClient.get(`/bookable-treatment-bundles/${treatmentPurposeReferenceId}/federal-states`)

  return data
}
